module.exports = __webpack_public_path__ + "static/media/dte-icon.ded08429.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dte-icon.svg
// module id = 271
// module chunks = 0